import {resources} from "../../../../../../../core/models/resource/resources";
import {EntityFileType} from "../../../../../../../core/types/file.types";

export const baseVideosFileResourceType = resources['base-video-files'];
export const aiVideosFileResourceType = resources['ai-video-files'];
export const packageDesignDetailFileResourceType = resources['package-design-details-files'];
export const rawPhotosFileResourceType = resources['raw-photo-files'];
export const rawVideosFileResourceType = resources['raw-video-files'];
export const otherContentFileResourceType = resources['other-content-files'];
export const mainPhotoFileResourceType = resources['main-photo-files'];

export const designBlockFilesPath: Record<string, string> = {
  baseVideos: baseVideosFileResourceType.path,
  aiVideos: aiVideosFileResourceType.path,
  packageDesignDetails: packageDesignDetailFileResourceType.path,
  rawPhotos: rawPhotosFileResourceType.path,
  rawVideos: rawVideosFileResourceType.path,
  otherContent: otherContentFileResourceType.path,
  mainPhoto: mainPhotoFileResourceType.path
}

export const designBlockEntityFileTypes: Record<string, EntityFileType> = {
  baseVideos: 'BASE_VIDEO',
  aiVideos: 'AI_VIDEO',
  packageDesignDetails: 'PACKAGE_DESIGN_DETAILS',
  rawPhotos: 'RAW_PHOTO',
  rawVideos: 'RAW_VIDEO',
  otherContent: 'OTHER_CONTENT',
  mainPhoto: 'MAIN_PHOTO'
}

export const designBlockGetFilesParamKeys: Record<string, string> = {
  baseVideos: 'baseVideoId',
  aiVideos: 'aiVideoId',
  packageDesignDetails: 'packageDesignDetailsId',
  rawPhotos: 'rawPhotoId',
  rawVideos: 'rawVideoId',
  otherContent: 'otherContentId',
  mainPhoto: 'mainPhotoId'
}
